import { useAuth } from '@/services/auth';
import { isFlexPlan } from '@/services/auth/plan-slugs';
import { type ActivityHistoryKind, gatedIncludedDays } from '../utils/activity-history';
import { useAddons } from './use-addons';
import { useOpenActivityHistoryAddon } from './use-open-activity-history-addon';
import { usePauseSafePermission } from './use-pause-safe-permission';

export type OlderHistoryNoticeModel = {
  kind: ActivityHistoryKind;
  includedDays: number;
  canEditBilling: boolean;
  openAddon: () => void;
};

/**
 * The notice for the end of a Flex activity list, or null when there is none to show: on other
 * plans, with the data retention add-on, and while the add-ons load.
 */
export function useOlderHistoryNotice(kind: ActivityHistoryKind): OlderHistoryNoticeModel | null {
  const { account } = useAuth();
  const { data: addons } = useAddons();
  const canEditBilling = usePauseSafePermission('account/billing/edit');
  const openAddon = useOpenActivityHistoryAddon();
  // Until they load, or when they fail to, a retention holder would see the upsell.
  if (!isFlexPlan(account) || addons == null) return null;
  if (addons.purchased.some((addon) => addon.product === 'data_retention')) return null;

  return {
    kind,
    includedDays: gatedIncludedDays(account, kind),
    canEditBilling,
    openAddon: () => void openAddon(),
  };
}
